export default "__VITE_ASSET__C$s3lOT7__"